namespace GeniuzPOS.Inventory {
    export interface IcStockDisassembleRow {
        Id?: number;
        SysDocNo?: string;
        DocNo?: string;
        DocDate?: string;
        RefDocNo1?: string;
        RefDocNo2?: string;
        CallAssemDocFg?: number;
        WhsSet?: string;
        WhsItem?: string;
        ExpDate?: string;
        Remark?: string;
        SetItemCode?: string;
        SetQty?: number;
        CalDtQtyFg?: number;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
        ApproveFg?: number;
        ApproveBy?: string;
        ApproveDate?: string;
        PostFg?: PostFgStatus;
        PostDate?: string;
        CancelFg?: CancelFgstatus;
        IcStockDisassembleDtList?: IcStockDisassembleDtRow[];
    }

    export namespace IcStockDisassembleRow {
        export const idProperty = 'SysDocNo';
        export const nameProperty = 'SysDocNo';
        export const localTextPrefix = 'Inventory.IcStockDisassemble';
        export const lookupKey = 'Inventory.IcStockDisassemble';

        export function getLookup(): Q.Lookup<IcStockDisassembleRow> {
            return Q.getLookup<IcStockDisassembleRow>('Inventory.IcStockDisassemble');
        }
        export const deletePermission = '2Inventory:การประกอบสินค้า:บันทึกรายการ:Modify';
        export const insertPermission = '2Inventory:การประกอบสินค้า:บันทึกรายการ:Modify';
        export const readPermission = '2Inventory:การประกอบสินค้า:บันทึกรายการ:View';
        export const updatePermission = '2Inventory:การประกอบสินค้า:บันทึกรายการ:Modify';

        export declare const enum Fields {
            Id = "Id",
            SysDocNo = "SysDocNo",
            DocNo = "DocNo",
            DocDate = "DocDate",
            RefDocNo1 = "RefDocNo1",
            RefDocNo2 = "RefDocNo2",
            CallAssemDocFg = "CallAssemDocFg",
            WhsSet = "WhsSet",
            WhsItem = "WhsItem",
            ExpDate = "ExpDate",
            Remark = "Remark",
            SetItemCode = "SetItemCode",
            SetQty = "SetQty",
            CalDtQtyFg = "CalDtQtyFg",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate",
            ApproveFg = "ApproveFg",
            ApproveBy = "ApproveBy",
            ApproveDate = "ApproveDate",
            PostFg = "PostFg",
            PostDate = "PostDate",
            CancelFg = "CancelFg",
            IcStockDisassembleDtList = "IcStockDisassembleDtList"
        }
    }
}
